import React, { useEffect, useState } from 'react';
import CancelSvg from 'assets/icons/modal-close.svg';
import { Button } from 'components/common';
import { useMarketplace } from '@thirdweb-dev/react';
import propertyService from 'services/propertyService';
import { useAccount } from 'wagmi';

interface AddFeatureProps {
  showModal: boolean;
  setShowModal: any;
  showBidModal: any;
  property: any;
}

const BuyPropertyModal = ({
  showModal,
  setShowModal,
  showBidModal,
  property,
}: AddFeatureProps) => {
  const { address } = useAccount();

  const marketplaceAddress = process.env.REACT_APP_MARKETPLACE_ADDRESS;
  const marketplace = useMarketplace(marketplaceAddress);

  const handleSubmit = async () => {
    // showBidModal();

    const listingId = 0;
    // Quantity of the asset you want to buy
    const quantityDesired = 1;

    const tx = await marketplace?.buyoutListing(
      property.listingId,
      quantityDesired
    );
    if (tx) {
      const res = await propertyService.sellProperty(property.propertyId, {
        owner: address,
      });

      setShowModal(false);
    }
  };

  const openBidModal = () => {
    showBidModal();
    setShowModal(false);
  };

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-[36rem] max-w-xl">
              <div className="bg-gray-4 border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-white text-2xl font-semibold">
                    Purchase this asset
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black  float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <img src={CancelSvg} alt="close-modal" />
                  </button>
                </div>

                <div className="relative p-6 flex-auto">
                  <p className="text-white opacity-70">
                    Do you wish to place a bid or buyout this asset?
                  </p>
                </div>

                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <Button
                    className="mr-4"
                    type="button"
                    onClick={() => setShowModal(false)}
                    variant="outline-danger"
                  >
                    Close
                  </Button>
                  {/* <button
                    className="bg-primary-2 text-white active:bg-primary-3 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={openBidModal}
                  >
                    Bid
                  </button> */}
                  <button
                    className="bg-primary-2 text-white active:bg-primary-3 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Buyout
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </>
      ) : null}
    </>
  );
};

export default BuyPropertyModal;
